export default __webpack_public_path__ + "static/media/delete_light.116a0408.svg";